import { z } from "zod";

/**
 * Recursively unwraps ZodEffects to get the core schema
 */
const unwrap = (schema: z.ZodSchema): z.ZodSchema =>
  schema instanceof z.ZodEffects ? unwrap(schema._def.schema) : schema;

/**
 * Determines if a field is optional by introspecting the Zod schema
 */
export const isFieldOptional = (
  schema: z.ZodSchema,
  fieldPath: string,
): boolean => {
  const unwrapped = unwrap(schema);
  return (
    unwrapped instanceof z.ZodObject &&
    unwrap(unwrapped.shape[fieldPath]) instanceof z.ZodOptional
  );
};

/**
 * Creates a label with optional indicator if the field is optional
 */
export const createSchemaAwareLabel = (
  baseLabel: string,
  fieldName: string,
  schema: z.ZodSchema,
) => {
  const isOptional = isFieldOptional(schema, fieldName);
  return isOptional ? (
    <>
      {baseLabel} - <i>optional</i>
    </>
  ) : (
    baseLabel
  );
};
